import { isProduction } from "./environment";
import { VirtualFolderInfo } from "./folderIdUtils/types";

// DOMAINS & ROUTES
export const SERVICE_NAME = "assetmanagement";
const domain = `zapier${isProduction ? "" : "-staging"}.com`;
export const API_ROUTE = "/api/asset-management-bff/trpc";
export const MONOLITH_BASE_URL = process.env.NEXT_PUBLIC_ZAPIER_ORIGIN;

export const ZAP_ROUTE = "/app/zaps";
export const INTERFACE_ROUTE = `https://interfaces.${domain}`;
export const TABLE_ROUTE = `https://tables.${domain}/app/tables`;
export const CHATBOT_ROUTE = "/app/chatbots/";
export const CHATBOT_API_ROUTE = "/api/chatbots/v0";
export const CONNECTION_ROUTE = "/app/connections/";
export const CANVAS_ROUTE = "/app/canvas/";
export const CANVAS_API_ROUTE = "/api/canvas/v1/";
export const EDITOR_ROUTE = "/webintent/edit-zap/";
export const PROJECTS_ROUTE = `/api/v1/projects`;
export const ASSETS_ROUTE = `/api/v1/assets`;

// EVENTS
export const EVENTS_SYSTEM_NAME = "assetmanagement";
export const USER_INTERACTION_EVENT =
  "web_analytics.tracking.user_interaction.UserInteractionEvent";
export const HIDE_MOVE_ZAP_WARNING = "hideMoveZapToSharedFolderWarning";
export const DEFAULT_VIEW_SETTINGS = "defaultViewSettings";

// PLACEHOLDERS
export const PLACEHOLDER_ICON = `https://cdn.${domain}/zapier/images/frontend/placeholder/64x64-new.grey.png`;
export const PLACEHOLDER_PROFILE_ICON = `https://cdn.${domain}/zapier/images/account-default-image.svg`;
export const PLACEHOLDER_APP_ICON =
  "https://cdn.zapier.com/zapier/images/frontend/placeholder/64x64-new.grey.png";

export const ZAP_PAGE_SIZE = 25;
export const FOLDERS_PAGE_SIZE = 25;
export const PROJECTS_PAGE_SIZE = 25;
export const UNTITLED_ZAP_DEFAULT = "Untitled Zap";
export const UNTITLED_ZAP_TITLE = `${UNTITLED_ZAP_DEFAULT}   `; // 💡 important: this string has 3 trailing spaces for find/replace

// FOLDER DEFAULTS
export const DEFAULT_FOLDER_ID = 0;
export const FOLDER_TRASH_ID = -1;
export const FOLDER_PENDING_ID = -3;
// Queued actions is not a folder but displays as a folder item on sidebar
export const FOLDER_QUEUED_ACTIONS_ID = -4;
// Pending approvals is not a folder but displays as a folder item on sidebar
export const FOLDER_PENDING_APPROVAL_ID = -5;
export const DEFAULT_FOLDER_NAME = "My Zaps";
export const PENDING_FOLDER_NAME = "Pending billing";
export const TRASH_FOLDER_NAME = "trash";

export const virtualFolderNames: Record<string, number> = {
  my_zaps_default_folder: DEFAULT_FOLDER_ID,
  pending: FOLDER_PENDING_ID,
  trash: FOLDER_TRASH_ID,
  queued_actions: FOLDER_QUEUED_ACTIONS_ID,
  pending_approval: FOLDER_PENDING_APPROVAL_ID,
};

export const virtualFolderIds = Object.values(virtualFolderNames);

export const virtualFoldersById: Record<string, VirtualFolderInfo> = {
  [String(DEFAULT_FOLDER_ID)]: {
    href: "/app/assets/zaps",
    name: DEFAULT_FOLDER_NAME,
  },
  [String(FOLDER_PENDING_ID)]: {
    href: "/app/assets/zaps?virtual=Pending+billing",
    name: PENDING_FOLDER_NAME,
  },
  [String(FOLDER_TRASH_ID)]: {
    href: "/app/assets/zaps?virtual=trash",
    name: TRASH_FOLDER_NAME,
  },
};

export const WOOTRIC_NO_SURVEYED_COOKIE = false; // Bypass cookie based throttle for testing purposes.
export const WOOTRIC_SURVEY_IMMEDIATELY = false; // Shows survey immediately for testing purposes.
